import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-pre-youtube-three-month-modal',
  templateUrl: './pre-youtube-three-month-modal.component.html',
  styleUrls: ['./pre-youtube-three-month-modal.component.scss'],
})
export class PreYoutubeThreeMonthModalComponent implements OnInit, OnDestroy {
  countdown = 3;
  acceptedTerms = false;
  private timer: any;

  constructor(
    private dialogRef: MatDialogRef<PreYoutubeThreeMonthModalComponent>
  ) {}

  ngOnInit(): void {
    this.startCountdown();
  }

  ngOnDestroy(): void {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  startCountdown(): void {
    this.timer = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(this.timer);
      }
    }, 1000);
  }

  onOk() {
    if (this.countdown === 0 && this.acceptedTerms) {
      this.dialogRef.close(true);
    }
  }
}
